import React from 'react';
import { BoardColumn } from '@/models/appState';
import { getDynamicIcon } from '@/utils/icon';

interface EmptyKanbanColumnProps {
  status: BoardColumn;
  isNewStyleEmptyColumn: boolean;
}

const EmptyKanbanColumn: React.FC<EmptyKanbanColumnProps> = ({
  status,
  isNewStyleEmptyColumn,
}) => {
  if (isNewStyleEmptyColumn) {
    const StatusIcon = status.icon
      ? getDynamicIcon({ name: status.icon, source: 'lucide' }) as React.ComponentType<{ className?: string }>
      : null;
    return (
      <div
        key={status.id}
        className="flex-shrink-0 w-32 bg-white rounded-lg shadow-sm h-24"
      >
        <div
          className={`flex-1 ${status.color} rounded-lg h-24 flex flex-col justify-center items-center`}
        >
          {StatusIcon && <StatusIcon className="w-5 h-5 mb-1 opacity-75" />}
          <span className="font-semibold text-sm">{status.title}</span>
          <span className="text-xs mt-1 px-2 py-0.5 bg-white/20 backdrop-blur-sm rounded-full">
            0
          </span>
        </div>
      </div>
    );
  }

  return (
    <div
      key={status.id}
      className="flex-shrink-0 w-32 bg-white rounded-lg shadow-sm h-24"
    >
      <div className={`${status.color} p-2 rounded-t-lg`}>
        <div className="flex items-center justify-between">
          <span className="font-semibold text-sm">{status.title}</span>
          <span className="px-2 py-1 bg-white rounded-full text-xs">
            0
          </span>
        </div>
      </div>
    </div>
  );
};

export default EmptyKanbanColumn;
